// When a finding no longer counts as "kræver handling": somebody has decided it (accepted risk, compensating control or false
// positive) and the decision still holds. A "Skal rettes" decision never settles anything (there is still something to do), and a
// decision whose review date has passed no longer holds, so the object is back among those that need action.
export const SETTLED_TYPES = ['accepted', 'compensating', 'falsepos'];

export function isSettledNote(note, now = Date.now()) {
  if (!note || !SETTLED_TYPES.includes(note.decisionType)) return false;
  if (!note.reviewDate) return true;
  const day = Date.parse(note.reviewDate);
  if (!Number.isFinite(day)) return true;
  // The review date itself still counts: the decision holds to the end of that day.
  return now < day + 24 * 60 * 60 * 1000;
}
